/**
 * QMS routes, legacy TargetView mapping, and screen metadata.
 */

export const QMS_ROUTE_PREFIX = "/qms";

export const LEGACY_TARGET_VIEW_TO_PERMISSION = {
  DMS_DASHBOARD: "QMS_DASHBOARD",
  DMS_COMPLIANCEREPORT: "QMS_COMPLIANCE_REPORT",
  DMS_ADDDOCUMENTTYPE: "QMS_DOCUMENT_TYPE",
  DMS_ADDDOCUMENTCATEGORY: "QMS_DOCUMENT_CATEGORY",
  DMS_VAULT: "QMS_VAULT",
  DMS_PUBLISH_DOCUMENTS: "QMS_PUBLISH_DOCUMENTS",
  DMS_DOCUMENTLIBRARY: "QMS_DOCUMENT_LIBRARY",
  DMS_CREATECHANGEREQUEST: "QMS_CREATE_CHANGE_REQUEST",
  DMS_CHANGEREQUESTS: "QMS_CHANGE_REQUESTS",
  DMS_TRACKER: "QMS_TRACKER",
  DMS_TRANSFEROWNERSHIP: "QMS_TRANSFER_OWNERSHIP",
  DMS_READINGLIST: "QMS_READING_LIST",
  DMS_ARCHIVEDOCUMENTS: "QMS_ARCHIVE_DOCUMENTS",
  DMS_CERTIFICATETEMPLATE: "QMS_CERTIFICATE_TEMPLATE",
  DMS_MYLEARNING: "QMS_MY_LEARNING",
  DMS_MYRECORDS: "QMS_MY_RECORDS",
  DMS_SHAREDWITHME: "QMS_SHARED_WITH_ME",
};

export const QMS_SCREENS = {
  dashboard: {
    screenKey: "dashboard",
    route: `${QMS_ROUTE_PREFIX}/dashboard`,
    title: "Dashboard",
    permissionKey: "QMS_DASHBOARD",
    legacyTargetView: "DMS_DASHBOARD",
    endpointKey: "DASHBOARD",
    probeActionType: "GetDMSDashboard",
    probePayload: {},
  },
  complianceReport: {
    screenKey: "complianceReport",
    route: `${QMS_ROUTE_PREFIX}/compliance-report`,
    title: "Reporting",
    permissionKey: "QMS_COMPLIANCE_REPORT",
    legacyTargetView: "DMS_COMPLIANCEREPORT",
    endpointKey: "DASHBOARD",
    probeActionType: "GetComplianceReportData",
  },
  documentTypes: {
    screenKey: "documentTypes",
    route: `${QMS_ROUTE_PREFIX}/document-types`,
    title: "Document Type",
    permissionKey: "QMS_DOCUMENT_TYPE",
    legacyTargetView: "DMS_ADDDOCUMENTTYPE",
    endpointKey: "DOCUMENT_TYPE",
    probeActionType: "GetAllDocumentType",
  },
  documentCategories: {
    screenKey: "documentCategories",
    route: `${QMS_ROUTE_PREFIX}/document-categories`,
    title: "Document Category",
    permissionKey: "QMS_DOCUMENT_CATEGORY",
    legacyTargetView: "DMS_ADDDOCUMENTCATEGORY",
    endpointKey: "DOCUMENT_CATEGORY",
    probeActionType: "GetAllDocumentCategory",
  },
  myVault: {
    screenKey: "myVault",
    route: `${QMS_ROUTE_PREFIX}/my-vault`,
    title: "My Vault",
    permissionKey: "QMS_VAULT",
    legacyTargetView: "DMS_VAULT",
    endpointKey: "MY_VAULT",
    probeActionType: "GetMyVaultDocuments",
  },
  publishDocuments: {
    screenKey: "publishDocuments",
    route: `${QMS_ROUTE_PREFIX}/publish`,
    title: "Publish Document",
    permissionKey: "QMS_PUBLISH_DOCUMENTS",
    legacyTargetView: "DMS_PUBLISH_DOCUMENTS",
    endpointKey: "MY_VAULT",
    probeActionType: "GetDocumentsForPublish",
  },
  documentLibrary: {
    screenKey: "documentLibrary",
    route: `${QMS_ROUTE_PREFIX}/library`,
    title: "Document Library",
    permissionKey: "QMS_DOCUMENT_LIBRARY",
    legacyTargetView: "DMS_DOCUMENTLIBRARY",
    endpointKey: "DOCUMENT_LIBRARY_V2",
    probeActionType: "GetDocumentLibraryDocuments_V2",
    probePayload: { PageNumber: 1, PageSize: 1 },
  },
  createChangeRequest: {
    screenKey: "createChangeRequest",
    route: `${QMS_ROUTE_PREFIX}/change-requests/create`,
    title: "Create Change Request",
    permissionKey: "QMS_CREATE_CHANGE_REQUEST",
    legacyTargetView: "DMS_CREATECHANGEREQUEST",
    endpointKey: "MY_VAULT",
    probeActionType: "GetDocumentLibraryDocuments",
  },
  changeRequests: {
    screenKey: "changeRequests",
    route: `${QMS_ROUTE_PREFIX}/change-requests`,
    title: "All Change Requests",
    permissionKey: "QMS_CHANGE_REQUESTS",
    legacyTargetView: "DMS_CHANGEREQUESTS",
    endpointKey: "CHANGE_REQUEST",
    probeActionType: "RequestsForMe",
  },
  documentControl: {
    screenKey: "documentControl",
    route: `${QMS_ROUTE_PREFIX}/document-control`,
    title: "Document Control",
    permissionKey: "QMS_DOCUMENT_CONTROL",
    legacyTargetView: null,
    endpointKey: "MY_VAULT",
    probeActionType: "GetDocumentControlList",
  },
  tracker: {
    screenKey: "tracker",
    route: `${QMS_ROUTE_PREFIX}/tracker`,
    title: "QMS Tracker",
    permissionKey: "QMS_TRACKER",
    legacyTargetView: "DMS_TRACKER",
    endpointKey: "TRACKER",
    probeActionType: "GetTrackerData",
  },
  transferOwnership: {
    screenKey: "transferOwnership",
    route: `${QMS_ROUTE_PREFIX}/transfer-ownership`,
    title: "Transfer Ownership",
    permissionKey: "QMS_TRANSFER_OWNERSHIP",
    legacyTargetView: "DMS_TRANSFEROWNERSHIP",
    endpointKey: "MY_VAULT",
    probeActionType: "GetTransferOwnershipData",
  },
  readingList: {
    screenKey: "readingList",
    route: `${QMS_ROUTE_PREFIX}/reading-list`,
    title: "Reading List",
    permissionKey: "QMS_READING_LIST",
    legacyTargetView: "DMS_READINGLIST",
    endpointKey: "MY_VAULT",
    probeActionType: "GetReadingList",
  },
  archiveDocuments: {
    screenKey: "archiveDocuments",
    route: `${QMS_ROUTE_PREFIX}/archive`,
    title: "Archive Documents",
    permissionKey: "QMS_ARCHIVE_DOCUMENTS",
    legacyTargetView: "DMS_ARCHIVEDOCUMENTS",
    endpointKey: "MY_VAULT",
    probeActionType: "GetArchiveDocumentList",
  },
  certificateTemplate: {
    screenKey: "certificateTemplate",
    route: `${QMS_ROUTE_PREFIX}/certificate-templates`,
    title: "Certificate Template",
    permissionKey: "QMS_CERTIFICATE_TEMPLATE",
    legacyTargetView: "DMS_CERTIFICATETEMPLATE",
    endpointKey: "CERTIFICATE_TEMPLATE",
    probeActionType: "GetCertificateTemplate",
  },
  quizManager: {
    screenKey: "quizManager",
    route: `${QMS_ROUTE_PREFIX}/quizzes`,
    title: "Quiz Manager",
    permissionKey: "QMS_QUIZ_MANAGER",
    legacyTargetView: null,
    endpointKey: "QUIZ_V2",
    probeActionType: "GetQuizzes_V2",
    probePayload: { PageNumber: 1, PageSize: 1 },
  },
  myLearning: {
    screenKey: "myLearning",
    route: `${QMS_ROUTE_PREFIX}/my-learning`,
    title: "My Learning",
    permissionKey: "QMS_MY_LEARNING",
    legacyTargetView: "DMS_MYLEARNING",
    endpointKey: "MY_LEARNING_V2",
    probeActionType: "GetMyLearningDocuments_V2",
    probePayload: { PageNumber: 1, PageSize: 1 },
  },
  myLearnings: {
    screenKey: "myLearnings",
    route: `${QMS_ROUTE_PREFIX}/my-learnings`,
    title: "My Learnings",
    permissionKey: "QMS_MY_LEARNING",
    legacyTargetView: "DMS_MYLEARNING",
    endpointKey: "MY_LEARNING_V2",
    probeActionType: "GetMyLearningsHub_V2",
    probePayload: { PageNumber: 1, PageSize: 1, LearningStatus: "All" },
  },
  myRecords: {
    screenKey: "myRecords",
    route: `${QMS_ROUTE_PREFIX}/my-records`,
    title: "My Records",
    permissionKey: "QMS_MY_RECORDS",
    legacyTargetView: "DMS_MYRECORDS",
    endpointKey: "MY_LEARNING",
    probeActionType: "GetMyRecordsDocuments",
  },
  sharedWithMe: {
    screenKey: "sharedWithMe",
    route: `${QMS_ROUTE_PREFIX}/shared-with-me`,
    title: "Shared With Me",
    permissionKey: "QMS_SHARED_WITH_ME",
    legacyTargetView: "DMS_SHAREDWITHME",
    endpointKey: "SHARED_WITH_ME",
    probeActionType: "GetSharedWithMeDocuments",
  },
};

export const QMS_SCREEN_LIST = Object.values(QMS_SCREENS);

export function getQmsScreen(screenKey) {
  return QMS_SCREENS[screenKey] || null;
}

/** Legacy QMS navy (ClinicalTrialWeb `--dmsColor` / `.dms_Link`). */
export const QMS_BRAND_COLOR = "#243f5a";

/**
 * Exact QMS sidebar order and icons from legacy MVC menu.
 * Document Type / Category are under QMS Config / eISF Config; not in QMS sidebar.
 */
export const QMS_SIDEBAR_MENU_ORDER = [
  { screenKey: "dashboard", icon: "fa fa-pie-chart" },
  { screenKey: "myVault", icon: "fa fa-folder" },
  { screenKey: "sharedWithMe", icon: "fa fa-share-alt", requiresReviewOrApprove: true },
  { screenKey: "publishDocuments", icon: "fa fa-globe" },
  { screenKey: "documentLibrary", icon: "fa fa-folder-open" },
  {
    screenKey: "documentControl",
    icon: "fa fa-tasks",
    // Document Control grants archive / unarchive / change owner; legacy keys still work.
    permissionKeys: [
      "QMS_DOCUMENT_CONTROL",
      "QMS_TRACKER",
      "QMS_TRANSFER_OWNERSHIP",
      "QMS_ARCHIVE_DOCUMENTS",
      "QMS_UNARCHIVE_DOCUMENTS",
    ],
  },
  {
    screenKey: "quizManager",
    icon: "fa fa-list-ol",
    // Quiz Manager grants all quiz/question actions; legacy granular keys still open the menu.
    permissionKeys: [
      "QMS_QUIZ_MANAGER",
      "QMS_QUIZ_ADD_EDIT",
      "QMS_QUIZ_DELETE",
      "QMS_QUESTION_ADD_EDIT",
      "QMS_QUESTION_DELETE",
      "QMS_QUESTION_IMPORT_BULK",
    ],
  },
  { screenKey: "myLearnings", icon: "fa fa-graduation-cap", permissionKeys: ["QMS_MY_LEARNING", "QMS_MY_RECORDS"] },
  { screenKey: "complianceReport", icon: "fa fa-bar-chart" },
];

export function getQmsSidebarSubItems() {
  return QMS_SIDEBAR_MENU_ORDER.map(({ screenKey, icon, requiresReviewOrApprove, permissionKeys }) => {
    const screen = QMS_SCREENS[screenKey];
    if (!screen) return null;
    return {
      name: screen.title,
      path: screen.route,
      permissionKey: screen.permissionKey,
      permissionKeys: permissionKeys || (screen.permissionKey ? [screen.permissionKey] : []),
      icon,
      requiresReviewOrApprove: Boolean(requiresReviewOrApprove),
    };
  }).filter(Boolean);
}
